import {metadaApi} from '@dms/api/base';

import {
  GetSvCloudBookingUrlApiArg,
  GetSvCloudBookingUrlApiArgSchema,
  GetSvCloudBookingUrlApiResponse,
  SvCloudBookingUrlResponseBodySchema,
} from './types';

const injected = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getSvCloudBookingUrl: build.query<GetSvCloudBookingUrlApiResponse, GetSvCloudBookingUrlApiArg>({
      query: (queryArg) => ({
        url: `/integration/v1/svcloud/booking-url`,
        params: {
          branchId: queryArg.branchId,
          resourceCode: queryArg.resourceCode,
          resourceId: queryArg.resourceId,
        },
      }),
      extraOptions: {
        requestSchema: GetSvCloudBookingUrlApiArgSchema,
        responseSchema: SvCloudBookingUrlResponseBodySchema,
      },
    }),
  }),
});

export const {useGetSvCloudBookingUrlQuery} = injected;
